import React from "react";
import {Field, reduxForm} from "redux-form/immutable";
import {List} from "immutable";
import ActionButton from "../../../components/ActionButton";
import FormFieldsTable from "../../../components/forms/FormFieldsTable";
import TextInputField from "../../../components/forms/TextInputField";
import TextAreaInputField from "../../../components/forms/TextAreaInputField";
import DropDownInputField from "../../../components/forms/DropDownInputField";
import FormError from "../../../components/forms/FormError";

export const FORM_NAME = "ClientDispatchForm";

// Creates or edits a client dispatch. `clients` are the active partners with
// the client role; `addresses` are the saved addresses of the chosen one.
// The origin can only be chosen when creating (`showOrigin`).
const ClientDispatchForm = (props) => {
  const {errors, handleSubmit, submit, submitting, warehouses, clients, addresses, showOrigin, showStordOrder, submitLabel} = props;
  const label = submitting ? "Standby..." : submitLabel;

  return (
    <form onSubmit={handleSubmit}>
      <div className="fields">
        <FormFieldsTable>
          {showOrigin &&
            <Field label="From Warehouse" name="originWarehouseId" component={DropDownInputField}
              data={warehouses} valueKey="id" titleKey="label" showBlank={true} serverError={errors.originWarehouseId} />}
          <Field label="Client" name="partnerId" component={DropDownInputField}
            data={clients} valueKey="partnerId" titleKey="name" showBlank={true} serverError={errors.partnerId} />
          <Field label="Deliver To" name="addressId" component={DropDownInputField}
            data={addresses || List()} valueKey="addressId" titleKey="label" showBlank={true} serverError={errors.addressId} />
          <Field label="Dispatch Date" name="dispatchDate" type="date" component={TextInputField} serverError={errors.dispatchDate} />
          <Field label="Client Reference" name="reference" component={TextInputField}
            placeholder="Their PO or shipment id, e.g. FBA15XYZ" serverError={errors.reference} />
          <Field label="Carrier Reference" name="carrierReference" component={TextInputField} serverError={errors.carrierReference} />
          {showStordOrder &&
            <Field label="Stord Order Number" name="stordOrderNumber" component={TextInputField}
              placeholder="When Stord ships it: the order number used in Stord" serverError={errors.stordOrderNumber} />}
          <Field label="Notes" name="notes" component={TextAreaInputField} rows={3} serverError={errors.notes} />
        </FormFieldsTable>
        {clients.size === 0 &&
          <p>No clients yet. Add one under Inventory → Clients &amp; Suppliers.</p>}
      </div>
      <FormError error={errors._error} />
      <div className="buttons">
        <ActionButton label={label} onClick={submit} active={!submitting} />
        <ActionButton label="Cancel" active={!submitting} onClick={props.onCancel} />
      </div>
    </form>
  )
}

export default reduxForm({form: FORM_NAME})(ClientDispatchForm);
